import * as React from "react";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { useMapContext } from "../../Contexts/MapContext";
import "./ToolbarSelect.scss";

export interface IToolbarSelect {
    value: string;
    values: string[];
    onChange: (value: string) => void;
    title?: string;
}

export const ToolbarSelect = ({ value, values, onChange, title }: IToolbarSelect): JSX.Element => {
    const { widget, setWidget } = useMapContext();
    const [expanded, setExpanded] = useState<boolean>(false);

    useEffect(() => {
        widget && setExpanded(false);
    }, [widget]);

    const onClick = () => {
        setWidget(null);
        setExpanded(!expanded);
    };
    const onSelect = (val: string) => {
        val.toLowerCase() !== value.toLowerCase() && onChange(val);
    };

    return (
        <div className={classNames("toolbar-select", "unselectable", { expanded })} title={title} onClick={onClick}>
            <div className="toolbar-button">
                <span>{value}</span>
                <div className="select-knob">
                    <span className="icon-geolite-chevron-down"></span>
                </div>
            </div>

            <div className={classNames("select-expandable", { expanded })}>
                {values.map((val) => (
                    <div key={val} onClick={() => onSelect(val)}>
                        {val.toUpperCase()}
                    </div>
                ))}
            </div>
        </div>
    );
};
